import { PRIVATE_ADMIN } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_ADMIN_LIST_PERMISSIONGROUPS = PRIVATE_ADMIN + '/list-permission-groups';
export const PRIVATE_ADMIN_FORM_PERMISSIONGROUP = PRIVATE_ADMIN + '/form-permission-group';